export default {
    Отвращение: "disgust",
    Удивление: "surprise",
    Страх: "fear",
    Печаль: "sadness",
    Интерес: "interest",
    Радость: "joy",
    Доверие: "trust",
}